module.exports = __webpack_public_path__ + "img/q5.c669815b.svg";